import { defineMessages } from 'react-intl';

export default defineMessages({
  seconds_ago: {
    id: 'kustomer.chat.time.ago.wrapper.seconds.ago.1',
    description: 'When time is under one minute',
    defaultMessage: 'Just now',
  },
});
